type Cell = string | number;

// Book titles and author lists routinely contain commas and quotes, so every
// cell is quoted and embedded quotes are doubled per RFC 4180.
function escapeCell(value: Cell): string {
  const text = String(value ?? '');
  return `"${text.replace(/"/g, '""')}"`;
}

export function toCsv(headers: string[], rows: Cell[][]): string {
  return [headers, ...rows].map((row) => row.map(escapeCell).join(',')).join('\r\n');
}

export function downloadCsv(filename: string, csv: string): void {
  // Excel only detects UTF-8 in a CSV if it starts with a byte order mark,
  // and these exports go to people opening them in Excel.
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function rangeSuffix(fromDate: string, toDate: string): string {
  return `${fromDate || 'start'}_to_${toDate || 'today'}`;
}
